<template>
  <div> 机构通讯录 </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped></style>
